module.exports = __webpack_public_path__ + "static/img/can.51b72764.png";